import React, {useEffect} from "react";
import useBanner from "./useBanner";
import {useNavigate, useParams} from "react-router-dom";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import {BANNER_TYPES} from "../../Constants/Constants";

export default function () {
  const {reset, bannerFields, handleSubmit, setData, setErrors} = useBanner();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/banners/${id}/edit`).then(res => {
      setData(res.data.data);
      let banner = res.data.banner;

      if (!banner.images?.length) {
        const bannerType = BANNER_TYPES?.[banner.type];

        banner.images = new Array(bannerType?.sizes?.length || 0).fill({
          desktop_image: '',
          mobile_image: '',
          url: '',
          shop_id: '',
        });
      }

      reset(banner);
    });
  }, []);

  const editBanner = data => {
    let formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      if (property !== 'images') {
        formData.append(`${property}`, value || '');
      }
    });

    data?.images?.forEach((item, index) => {
      Object.entries(item).forEach(([property, value]) => {
        formData.append(`images[${index}][${property}]`, value || '');
      });
    });

    formData.append("_method", "PUT");

    axios.post(`/banners/${id}`, formData).then(res => {
      navigate('/banners');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data.errors || {});
      }
    })
  }

  return (
    <Card title="Edit banner">
      <form className="form w-100 row" onSubmit={handleSubmit(editBanner)}>
        {bannerFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}